{
  "SIN": "Social Insurance Number",
  "BN": "Business Number",
  "SSN": "Social Security Number",
  "EIN": "Employer Identification Number",
  "ITIN": "Individual Taxpayer Identification Number",
  "GENERIC": "Tax Identification Number",
  "abbreviated": {
    "SIN": "SIN",
    "BN": "BN",
    "SSN": "SSN",
    "EIN": "EIN",
    "ITIN": "ITIN",
    "GENERIC": "TIN"
  }
}
